import { render } from './main'; // Import first so that we get babel transforms
import AccountsApp from '../accounts';
import './styles.jsx';

// Add in a top level classname to the body so that we can customize the css of the entire container
const body = document.getElementsByTagName('body')[0];
body.classList.add('Accounts--Body');

render(AccountsApp);
